import React, { FC } from 'react'
import { useAddTrailerToOrganization } from 'ui/modals/AddTrailerToOrganization/AddTrailerToOrganization-ViewModel'
import { Shared } from 'ui/shared'
import { Form } from 'utils/helpers/form'
import Grid from '@mui/material/Grid'

export const AddTrailerToOrganization: FC = () => {
  const vm = useAddTrailerToOrganization()
  const { closeModal, form, isLoading, t } = vm
  const { errors, handleSubmit, control, trailersOptions } = form

  return (
    <Shared.Card style={{ width: 375 }}>
      <form autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Shared.CardTitle title={t('title')} />
          </Grid>

          <Grid item xs={12}>
            <Shared.Dropdown
              name="trailerId"
              label={t('trailer')}
              options={trailersOptions}
              fullWidth
              control={control}
              rules={Form.required}
              error={errors.trailerId?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.Button
              style={{ margin: '3.75em 0 0.875em 0' }}
              color={'secondary'}
              title={t('cancel')}
              onClick={closeModal}
            />
            <Shared.Button title={t('submit')} type={'submit'} />
          </Grid>

          {isLoading && <Shared.Preloader mask />}
        </Grid>
      </form>
    </Shared.Card>
  )
}
